export default [
  {
    path: '/pledge-2024/index',
    name: 'index',
    component: () => import('@/views/pledge-2024'),
    meta: {
      title: '2024高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2024/pledgepersonal',
    name: 'pledgepersonal',
    component: () => import('@/views/pledge-2024/pledgepersonal'),
    meta: {
      title: '2024高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2024/pledgelist',
    name: 'pledgelist',
    component: () => import('@/views/pledge-2024/pledgelist'),
    meta: {
      title: '2024高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2024/pledgeform',
    name: 'pledgeform',
    component: () => import('@/views/pledge-2024/pledgeform'),
    meta: {
      title: '2024高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2024/pledgeupload',
    name: 'pledgeupload',
    component: () => import('@/views/pledge-2024/pledgeupload'),
    meta: {
      title: '2024高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2024/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge-2024/blessing'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
  },
  {
    path: '/pledge-2024/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge-2024/myblessing'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
},
  {
    path: '/pledge-2024/mypledge',
    name: 'mypledge',
    component: () => import('@/views/pledge-2024/mypledge'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
  },{
    path: '/pledge-2024/pledgeinfo',
    name: 'pledgeinfo',
    component: () => import('@/views/pledge-2024/pledgeinfo'),
    meta: {
      title: '2024高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2024/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge-2024/blessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2024高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge-2024/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge-2024/myblessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2024高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge-2024/lotteryRecord',
    name: 'lotteryRecord',
    component: () => import('@/views/pledge-2024/lotteryRecord'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  },
  {
    path: '/pledge-2024/lottery',
    name: 'lottery',
    component: () => import('@/views/pledge-2024/lottery'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  }
]
